import React from 'react'
import Img from 'gatsby-image'

import { TileTransitionLink } from '../contexts/TileTransition'

import useInView from '../hooks/useInView'

import { media } from '../styles/tools'

import Space from '../components/Space'
import { Slide, Reveal } from '../components/Animated'
import { ColorHeadline, WideText } from '../styles/typography'

import { projectURL } from '../projects'

const ProjectTile = ({
  offsetTitle,
  textType = 'title',
  data: { key, title, headlineMarkup, color, colors, image },
  ...props
}) => {
  const [ref, inView] = useInView()

  return (
    <div ref={ref} {...props}>
      <TileTransitionLink
        to={projectURL(key)}
        imgSrc={image.src}
        className="hoverWideText"
        css={{
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
        }}
      >
        <Slide
          left
          inView={inView}
          translate={80}
          css={{ position: 'absolute', zIndex: 1, left: 0 }}
        >
          {offsetTitle && <Space y={offsetTitle} />}
          <ColorHeadline underlineColors={colors}>
            {
              { title: <span>{title}</span>, headline: headlineMarkup }[
                textType
              ]
            }
          </ColorHeadline>
          <Space y={{ tablet: 25 }} />
          <Slide
            left
            inView={inView}
            translate={80}
            delay={250}
            css={{ [media.max.tablet]: { display: 'none' } }}
          >
            <WideText>VIEW CASE STUDY</WideText>
          </Slide>
        </Slide>
        <div
          css={{
            width: '87.5%',
            marginLeft: '12.5%',
            [media.mobileLg]: {
              width: '75%',
              marginLeft: '25%',
            },
          }}
        >
          <Reveal left className="TileImg" inView={inView} color={color}>
            <Img fluid={{ ...image, aspectRatio: 1.5 }} />
          </Reveal>
        </div>
      </TileTransitionLink>
    </div>
  )
}

export default ProjectTile
